import { Download, FileText } from "lucide-react";

const AnalyticsPdfExportAction = ({
  rangeLabel,
  scopeLabel = "All Muqami",
  loading = false,
  error = "",
  onExport,
}) => {
  return (
    <div className="rounded-3xl bg-white p-5 shadow">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-3">
          <div className="rounded-2xl bg-zinc-100 p-3 text-zinc-700">
            <FileText size={20} aria-hidden="true" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-zinc-900">
              PDF Report
            </h2>
            <p className="mt-1 text-sm text-zinc-500">
              Export every analytics category for {rangeLabel} across {scopeLabel}.
            </p>
            {error ? <p className="mt-2 text-sm text-red-600">{error}</p> : null}
          </div>
        </div>

        <button
          type="button"
          onClick={onExport}
          disabled={loading}
          className="inline-flex items-center justify-center gap-2 rounded-xl bg-zinc-900 px-4 py-2 text-sm font-medium text-white transition hover:bg-zinc-800 disabled:cursor-not-allowed disabled:opacity-70"
        >
          <Download size={16} aria-hidden="true" />
          {loading ? "Preparing PDF..." : "Export PDF"}
        </button>
      </div>
    </div>
  );
};

export default AnalyticsPdfExportAction;
